'use client'

export default function myImageLoader({ src, width, quality }) {
  if (src.startsWith('https://cdn.nowaycdn.com/images/champions/') && /\/(splash|loading)\//.test(src)) {
    const size = width <= 384 ? '384x' : width <= 768 ? '768x' : width <= 1280 ? '1280x' : 'full';
    return src.replace(/\/(splash|loading)\/(384x|768x|1280x|full)\//, `/$1/${size}/`);
  }
  if (src.startsWith('http://') || src.startsWith('https://') || src.startsWith('/static/')) {
    return src;
  }
  return `https://cdn.nowaycdn.com/images/${src}`
}

